import React, { type FC, type ReactElement } from "react";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaInfoCircle,
} from "react-icons/fa";

import Modal from "@components/modal";

const enum AlertType {
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  SUCCESS = "success",
}

const AlertModal: FC<{
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  type?: string;
  closeOnBackgroundClick?: boolean;
  children?: any;
}> = ({
  isModalOpen,
  setIsModalOpen,
  type = AlertType.INFO,
  closeOnBackgroundClick = true,
  children,
}): ReactElement => {
  const getIcon = (): ReactElement => {
    let element = null;
    switch (type) {
      case AlertType.INFO:
      default:
        element = <FaInfoCircle className="size-full text-primary" />;
        break;
      case AlertType.WARNING:
        element = <FaExclamationCircle className="size-full text-primary" />;
        break;
      case AlertType.ERROR:
        element = <FaExclamationCircle className="size-full text-red-500" />;
        break;
      case AlertType.SUCCESS:
        element = <FaCheckCircle className="size-full text-secondary" />;
        break;
    }
    return element;
  };
  return (
    <Modal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      isCloseButtonExist={false}
      closeOnBackgroundClick={closeOnBackgroundClick}
      badge={
        <span className="absolute left-1/2 top-0 z-30 size-20 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white p-2">
          {getIcon()}
        </span>
      }
    >
      <div className="mt-4 w-full">{children}</div>
    </Modal>
  );
};

export default AlertModal;
